import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FaIcon from '../FaIcon'
import css from './style.module.scss'

export default class Button extends Component {
  static propTypes = {
    type: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
    gray: PropTypes.bool,
    white: PropTypes.bool,
    block: PropTypes.bool,
    tiny: PropTypes.bool,
    small: PropTypes.bool,
    disabled: PropTypes.bool,
    spinner: PropTypes.bool,
    iconLeft: PropTypes.bool,
    iconRight: PropTypes.bool,
    transparent: PropTypes.bool,
    className: PropTypes.string,
    href: PropTypes.string,
    WrappedComponent: PropTypes.func
  }

  static defaultProps = {
    type: 'button'
  }

  render () {
    const {
      text, gray, block, tiny, small, disabled,
      spinner, transparent, iconLeft, iconRight,
      className, href, children, WrappedComponent, white, name, type, ...props
    } = this.props

    const classes = classNames(className, css.btn, {
      [css.disabled]: disabled,
      [css.gray]: gray,
      [css.block]: block,
      [css.tiny]: tiny,
      [css.small]: small,
      [css.iconLeft]: iconLeft,
      [css.iconRight]: iconRight,
      [css.transparent]: transparent,
      [css.white]: white
    })

    let spinnerTag
    if (spinner) {
      spinnerTag = <FaIcon name='cog' spin className={css.spinner} />
    }

    const btnTextClass = spinner ? css.hideBtnText : null

    if (WrappedComponent) {
      return (
        <WrappedComponent {...props} className={classes} role='button'>
          <span className={btnTextClass}>{text || children}</span>
          {spinnerTag}
        </WrappedComponent>
      )
    } else if (!href) {
      return (
        <button data-automation={`${name}_Button`} {...props} disabled={disabled} name={name} type={type} className={classes} role='button'>
          <span className={btnTextClass}>{text || children}</span>
          {spinnerTag}
        </button>
      )
    } else {
      return (
        <a href={href} {...props} className={classes} role='button'>
          <span className={btnTextClass}>{text || children}</span>
          {spinnerTag}
        </a>
      )
    }
  }
}
